import { IconWrapper } from '../runtime';
export default IconWrapper('shield', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6 7.89549L7.75 9.64549L10.5 6.89549M5.5 2.39549C4.76891 2.67114 3.74445 2.79493 2.99277 2.85046C2.44425 2.89098 2 3.33966 2 3.88967V8.90351C2 10.179 2.50667 11.4022 3.40854 12.304C4.12955 13.025 4.98153 13.6019 5.91876 14.0035L7.81554 14.8164C7.93333 14.8669 8.06667 14.8669 8.18446 14.8164L10.0812 14.0035C11.0185 13.6019 11.8704 13.025 12.5915 12.304C13.4933 11.4022 14 10.179 14 8.90351V3.88967C14 3.33966 13.5557 2.89098 13.0072 2.85046C12.2555 2.79493 11.2311 2.67114 10.5 2.39549C9.88057 2.16193 9.13629 1.69287 8.62175 1.34112C8.24879 1.08616 7.75121 1.08616 7.37825 1.34112C6.86371 1.69287 6.11943 2.16193 5.5 2.39549Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});